<template>
  <div class="wishlist">
    <KaaliWishlist
      v-if="type === 'kaali'"
      :productId="productId"
      :inWishlist="inWishlist"
    />
  </div>
</template>

<script>
import KaaliWishlist from '@/components/general-ui/wishlists/Kaali.vue';

export default {
  name: 'Wishlist',
  components: {
    KaaliWishlist,
  },
  props: {
    productId: Number
  },
  data() {
    return {
      inWishlist: false,
      type: ws_vue_store.config['single-product-wishlist'],
    };
  },
  mounted: function(){
    let that = this;
    let found = Object.values(ws_vue_store.wishlist_products).some(function(prod){
      return prod.product_id == that.productId || prod.variation_id == that.productId;
    });
    if(found){
      this.inWishlist = true;
    }
  },
  computed: {

  },
  methods: {

  },
};
</script>
